import { Dialog, DialogActions, DialogContent } from "@mui/material"
import { DialogHeader } from "../../../auth/components/DialogHeader"
import DangerBaseButton from "../../../main/components/DangerBaseButton"
import { InversorString } from "./DiagramaUnifilar"
import RopTable, { TableRowType } from "../../../main/components/RopTable/RopTable"

export type StringsModalProps = {
    currentInversor: { ugIndex: number, inversorIndex: number, strings?: InversorString[] }
    open: boolean
    onClose: () => void
}

export default function StringsModal(props: StringsModalProps) {
    const { currentInversor, open, onClose } = props

    const tableRows: TableRowType[] = currentInversor.strings?.map((string) => {
        return {
            rowItems: [
                {
                    item: string.stringNumber,
                    align: "center",
                    isMobile: true,
                },
                {
                    item: string.corrente != null
                        ? string.corrente.toLocaleString("pt-BR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })
                        : "Sem dados",
                    align: "center",
                    isMobile: true,
                }]
        }
    }) ?? []

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="customized-dialog-title"
            >
                <DialogHeader id="customized-dialog-title" onClose={onClose}>
                    UG {currentInversor.ugIndex} - Inversor {currentInversor.inversorIndex}
                </DialogHeader>
                <DialogContent
                    sx={{
                        width: "100%",
                        height: "100%",
                        maxHeight: "505px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "clip",
                    }}
                    dividers
                >
                    <RopTable
                        sxCardBox={{ marginLeft: { xs: "10px", md: "0px" }, width: "100%", maxHeight: "445px" }}
                        hover
                        itemsHeaders={[
                            {
                                item: "Número da String",
                                isMobile: true,
                                align: "center",
                            },
                            {
                                item: "Corrente CC (A)",
                                align: "center",
                                isMobile: true,
                            },
                        ]}
                        itemRows={tableRows}
                    />
                </DialogContent>
                <DialogActions>
                    <DangerBaseButton onClick={onClose} title="Fechar" />
                </DialogActions>
            </Dialog>
        </>
    )
}